import BlotFormatter from "quill-blot-formatter";
import { useCallback, useMemo, useRef } from "react";
import QuillEditor, { Quill } from "react-quill";
import "react-quill/dist/quill.snow.css";

Quill.register("modules/blotFormatter", BlotFormatter);

const TextEditor = ({ value, onChange, placeholder }) => {
  const quill = useRef();

  const imageHandler = useCallback(() => {
    const input = document.createElement("input");
    input.setAttribute("type", "file");
    input.setAttribute("accept", "image/*");
    input.click();

    input.onchange = () => {
      const file = input.files[0];
      const reader = new FileReader();

      reader.onload = () => {
        const imageUrl = reader.result;
        const quillEditor = quill.current.getEditor();
        const range = quillEditor.getSelection(true);
        quillEditor.insertEmbed(range.index, "image", imageUrl, "user");
      };

      reader.readAsDataURL(file);
    };
  }, []);

  const modules = useMemo(
    () => ({
      blotFormatter: {
        overlay: {
          style: { border: "2px solid red" }
        }
      },
      toolbar: {
        container: [
          [{ header: [2, 3, 4, false] }],
          ["bold", "italic", "underline", "strike", "blockquote"],
          [{ color: [] }],
          [{ list: "ordered" }, { list: "bullet" }, { indent: "-1" }, { indent: "+1" }],
          ["link", "code"],
          ["clean"]
        ],
        handlers: {
          image: imageHandler
        }
      },
      clipboard: {
        matchVisual: true
      }
    }),
    [imageHandler]
  );

  const formats = [
    "header",
    "bold",
    "italic",
    "underline",
    "strike",
    "blockquote",
    "list",
    "bullet",
    "indent",
    "link",
    "image",
    "color",
    "clean",
    "code"
  ];

  return (
    <>
      <QuillEditor
        ref={(el) => (quill.current = el)}
        theme="snow"
        style={{ height: "200px" }}
        value={value || ""}
        formats={formats}
        modules={modules}
        onChange={onChange}
        placeholder={placeholder}
      />
    </>
  );
};

export default TextEditor;
